import { render, staticRenderFns } from "./SubmitWaste.vue?vue&type=template&id=7b7f3672&"
import script from "./SubmitWaste.vue?vue&type=script&lang=js&"
export * from "./SubmitWaste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports